import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/shared/services/api.service";
import { ICredentials } from "../../epicare-public/login/domain/interfaces/login.interface";
import { IOrganizationAccess } from "../interfaces/access.interface";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private api: ApiService) {}

  /**
   * Logs in a user with credentials and optional 2FA.
   * @param credentials User credentials with optional 2FA.
   * @return Access and refresh tokens, along with the functionalities and routes the
   * invitee's role in the organization grants access to
   */
  public login(credentials: ICredentials): Observable<IOrganizationAccess> {
    let headerParams;
    if (credentials.code2FA) {
      headerParams = { Authorization: "2FA " + credentials.code2FA };
      delete credentials.code2FA;
    }

    let params;

    if (credentials.sendCodeTo?.telecomType === "email") {
      params = { email: credentials.sendCodeTo.value };
      delete credentials.sendCodeTo;
    }
    return this.api.post("user/auth", credentials, headerParams, false, params) as Observable<IOrganizationAccess>;
  }

  /**
   * Logs out the current user.
   * @return An observable that completes once the logout request succeeds
   */
  public logout(): Observable<void> {
    return this.api.post("user/logout", {}) as Observable<void>;
  }
}
